import http from "./http";

const getCustomer = (params, cancelToken) => {
  return http.get("/customers/customers-paginated", {
    params,
    cancelToken,
  });
};
const getCustomerList = () => {
  return http.get("/customers/customers");
};

const getCustomerByOne = (id) => {
  return http.get(`/customers/customer-by-id`, {
    params: {
      id: id
    }
  });
};

const createCustomer = (data) => {
  return http.post("/customers", data);
};


const updateCustomer = (data) => {
  return http.put("/customers", data);
};

const removeCustomer = (id) => {
  return http.delete(`/customers`, { 
    params: { id }
  });
};

const updateGroupCustomer = (id, customer_ids) => {
  return http.patch(`/admin/${id}/customers`, {
    customer_ids,
  });
};

export default {
  getCustomer,
  getCustomerByOne,
  getCustomerList,
  createCustomer,
  updateCustomer,
  removeCustomer,
  updateGroupCustomer,
};
